import { useRouter } from "next/router";
import qs from "query-string";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";

export const useDevices = ({
    companyId,
    locationId,
    query,
}: {
    companyId?: string;
    locationId?: string;
    query?: { filter?: string; deviceType?: string; startDate?: string } | null;
}) => {
    const queryString = query ? `?${qs.stringify(query)}` : "";

    const router = useRouter();

    const getAPI = () => {
        if (!companyId) {
            return "/api/device-management/v1/devices";
        }
        if (!locationId) {
            return `/api/device-management/v1/companies/${companyId}/devices`;
        }
        return `/api/device-management/v1/companies/${companyId}/locations/${locationId}/devices`;
    };
    const { data, error, isLoading, mutate } = useSWR(
        [getAPI() + queryString, router.locale],
        ([url]) => fetcher(url),
        {
            fallbackData: [],
        }
    );

    return {
        devices: data,
        isLoadingDevices: isLoading,
        isError: error,
        mutateDevices: mutate,
    };
};

export const usePostDeviceRequest = ({
    companyId,
    locationId,
    onSuccess,
    onError,
}: {
    companyId?: string;
    locationId?: string;
    onSuccess?: (data: any) => void;
    onError?: (err: any, key: string) => void;
}) => {
    const {
        data: deviceRequest,
        trigger: triggerPostDeviceRequest,
        isMutating: isLoadingPostDeviceRequest,
        reset: resetPostDeviceRequest,
    } = useSWRMutation(
        !!companyId && !!locationId
            ? `/api/device-management/v1/companies/${companyId}/locations/${locationId}/device-request`
            : "/api/device-management/v1/device-request",
        (
            url: string,
            {
                arg,
            }: {
                arg: { body: any };
            }
        ) =>
            fetcher(url, {
                options: {
                    method: API_REST_METHODS.POST,
                    body: JSON.stringify(arg.body),
                },
            }),
        {
            onSuccess,
            onError,
        }
    );

    return {
        deviceRequest,
        triggerPostDeviceRequest,
        isLoadingPostDeviceRequest,
        resetPostDeviceRequest,
    };
};
